<template>
    <div class="service-summary">
        <div class="service-summary-search-area">
            <lgn-input class="service-summary-search-area-item" placeholder="搜尋" v-model="searchText" 
            :suffix="true" :suffix-icon="'el-icon-search'" :suffix-method="searchSites"
            @keyup.enter.native="searchSites"></lgn-input>
        </div>
        <div class="service-summary-group-area">
            <button type="button" @click="changeMobileView('class')" class="service-summary-group-area-item" :class="{'is-active': viewStaticArea == 'class'}">
                <div class="service-summary-group-area-item-img el-icon-pie-chart">
                </div>
                <div class="service-summary-group-area-item-label">類型</div>
            </button>
            <button type="button" @click="changeMobileView('net')" class="service-summary-group-area-item" :class="{'is-active': viewStaticArea == 'net'}">
                <div class="service-summary-group-area-item-img el-icon-link">
                </div>
                <div class="service-summary-group-area-item-label">連線</div>
            </button>
        </div>
        <div class="service-summary-warp twice">
            <div class="service-summary-warp-content production" :class="{'mobile-show': viewStaticArea == 'class'}">
                <div class="service-summary-warp-content-title">場站類型</div>
                <svg class="service-summary-warp-content-draw" v-show="wattingSiteConnection"></svg>
                <div class="service-summary-warp-content-description" v-show="wattingSiteConnection">
                    <button class="service-summary-warp-content-description-item" 
                    :class="[`production-${index}`]" v-for="(item, index) in sortByVersionList" :key='index'
                    @click="searchProduction(item[0])">
                        <div class="service-summary-warp-content-description-item-key">{{item[0]}}</div>
                        <div class="service-summary-warp-content-description-item-value">{{item[1]}}</div>
                    </button>
                    <div class="service-summary-warp-content-description-total">
                        <div class="service-summary-warp-content-description-total-label">總數：</div>
                        <div class="service-summary-warp-content-description-total-value">{{sortByVersionLength}}</div>
                    </div>
                </div>
                <div class="admin-summary-warp-content-watting" v-show="!wattingSiteConnection">
                    <i class="el-icon-loading"></i>
                </div>
            </div>
            <div class="service-summary-warp-content connection" :class="{'mobile-show': viewStaticArea == 'net'}">
                <div class="service-summary-warp-content-title">連線狀態</div>
                <svg class="service-summary-warp-content-draw" v-show="wattingProduction"></svg>
                <div class="service-summary-warp-content-description" v-show="wattingProduction">
                    <button type="button" class="service-summary-warp-content-description-item" 
                    :class="[`connection-${index}`]" v-for="(item, index) in siteConnectionList" :key='index'
                    @click="searchNetconnection(item[0])" :disabled="item[0] == '正常'">
                        <div class="service-summary-warp-content-description-item-key">{{item[0]}}</div>
                        <div class="service-summary-warp-content-description-item-value">{{item[1]}}</div>
                    </button>
                </div>
                <div class="service-summary-warp-content-watting" v-show="!wattingProduction">
                    <i class="el-icon-loading"></i>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import * as api from '@/script/apiService/api.js'
import lgnInput from '@/lgnComponents/lgnInput/lgnInput.vue'
import d3 from 'd3'
export default {
    name: "ServiceSummary",
    data(){
        return{
            sortBySiteList: [],
            sortByVersionLength: 0,
            operatorSiteList: [],
            sortByVersionList: [],
            smartgateList: null,
            AllSiteList: null,
            netErrorSiteList: null,
            siteConnectionList: [],
            viewMoreOperator: false,
            wattingSiteConnection: false,
            wattingProduction: false,
            wattingOperatorPie: false,
            viewStaticArea: 'class',
            viewStaticAreaOption: [
                {label: '場站類型', value: 0},
                {label: '連線狀態', value: 1},
            ],
            searchText: ''
        }
    },
    components: {
        lgnInput
    },
    methods: {
        async getSortByVersionList(){
            let res = null;
            res = await api.postServiceSiteSearch();
            if(!res.error_status){
                this.AllSiteList = ['正常', res.length];
                let smartgateList = ['Smartgate', 0];
                let towerParkerList = ['TowerParker', 0];
                let fetcAgentList = ['FetcAgent', 0];
                res.forEach(function(item){
                    let productionName = item.sw.split(" ")[0];
                    if(productionName == 'Smartgate'){
                        smartgateList[1] += 1;
                    } else if(productionName == 'TowerParker'){
                        towerParkerList[1] += 1;
                    } else if(productionName == 'FetcAgent'){
                        fetcAgentList[1] += 1;
                    }
                }.bind(this));
                this.sortByVersionLength = smartgateList[1] + towerParkerList[1] + fetcAgentList[1];
                this.sortByVersionList = [smartgateList, towerParkerList, fetcAgentList];
            } else if(res.error_status != '401' && res.error_status != '504'){
                this.$message.error({
                    duration: 2500,
                    showClose: true,
                    message: "發生錯誤!"
                })
            }
        },
        async getNetErrorSiteList(){
            let res = await api.postServiceSiteSearch('', "updated");
            if(!res.error_status){
                this.netErrorSiteList = ['中斷', res.length];
            } else if(res.error_status != '401' && res.error_status != '504'){
                this.$message.error({
                    duration: 2500,
                    showClose: true,
                    message: "發生錯誤!"
                })
            }
        },
        drawProductionPie(){
            let svgWidth = 160;
            let svgHeight = 160;
            let dataset = this.sortByVersionList;
            let pieColor= [
                d3.rgb(74, 127, 176), d3.rgb(91, 155, 213), d3.rgb(173, 198, 229)
            ]
            let beClearElement = document.querySelector(".service-summary-warp-content.production .service-summary-warp-content-draw");
            let beClearNodes = beClearElement.childNodes;
            for(let i = beClearNodes.length - 1; i >= 0; i--){
                beClearElement.removeChild(beClearNodes[i]);
            }
            let root = d3.select(".service-summary-warp-content.production .service-summary-warp-content-draw");
            let pie = d3.layout.pie().sort(null).value(d => d[1]);
            let pieData = pie(dataset);
            let arc = d3.svg.arc().innerRadius(0).outerRadius(svgWidth/2);
            let arcs = root.selectAll("g").data(pieData).enter().append("g").attr("transform", `translate(${svgWidth / 2}, ${svgHeight / 2})`); 
            arcs.append("path").attr("fill", (d, i) => pieColor[i]).attr("d", d => arc(d));
        },
        drawSiteConnectionPie(){
            let svgWidth = 160;
            let svgHeight = 160;
            this.AllSiteList[1] -= this.netErrorSiteList[1];
            let dataset = [this.AllSiteList, this.netErrorSiteList];
            this.siteConnectionList = dataset;
            let pieColor= [
                d3.rgb(204, 229, 212), d3.rgb(220, 109, 11), d3.rgb(204,213,230)
            ]
            let beClearElement = document.querySelector(".service-summary-warp-content.connection .service-summary-warp-content-draw");
            let beClearNodes = beClearElement.childNodes;
            for(let i = beClearNodes.length - 1; i >= 0; i--){
                beClearElement.removeChild(beClearNodes[i]);
            }
            let root = d3.select(".service-summary-warp-content.connection .service-summary-warp-content-draw");
            let pie = d3.layout.pie().sort(null).value(d => d[1]);
            let pieData = pie(dataset);
            let arc = d3.svg.arc().innerRadius(0).outerRadius(svgWidth/2);
            let arcs = root.selectAll("g").data(pieData).enter().append("g").attr("transform", `translate(${svgWidth / 2}, ${svgHeight / 2})`); 
            arcs.append("path").attr("fill", (d, i) => pieColor[i]).attr("d", d => arc(d));
        },
        searchSites(){
            if(this.searchText.trim().length == 0){
                this.$message.error({
                    duration: 2500,
                    showClose: true,
                    message: "請輸入關鍵字!"
                })
                return false;
            }
            this.$router.push({
                name: 'UserSite',
                params: {
                    site: this.searchText
                }
            })
        },
        searchProduction(production){
            this.$router.push({
                name: 'UserSite',
                params: {
                    site: production
                }
            })
        },
        searchNetconnection(netStatus){
            if(netStatus == '中斷'){
                this.$router.push({
                    name: 'UserSite',
                    params: {
                        status: 1,
                        site: ''
                    }
                })
            }
        },
        changeMobileView(key){
            this.viewStaticArea = key;
        }
    },
    watch: {
    },
    async mounted(){
        this.wattingSiteConnection = false;
        this.wattingProduction = false;
        this.wattingOperatorPie = false;
        await this.getSortByVersionList();
        await this.getNetErrorSiteList();
        this.drawSiteConnectionPie();
        this.wattingSiteConnection = true;
        this.drawProductionPie();
        this.wattingProduction = true;
    }
}
</script>